"use strict";

exports.__esModule = true;
exports.CheckboxGroupRoot = exports.CheckboxRoot = void 0;

var _Choice = _interopRequireDefault(require("../Choice/Choice"));

var _ChoiceGroup = _interopRequireDefault(require("../Choice/ChoiceGroup"));

var _themes = require("../themes");

var _themes2 = require("./themes");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CheckboxRoot = (0, _themes.themed)(_Choice.default)(function (_ref) {
  var baseTheme = _ref.theme;
  return (0, _themes.mapComponentThemes)({
    name: 'Checkbox',
    theme: (0, _themes2.checkboxTheme)(baseTheme)
  }, {
    name: 'Choice',
    theme: {}
  }, baseTheme);
});
exports.CheckboxRoot = CheckboxRoot;
var CheckboxGroupRoot = (0, _themes.themed)(_ChoiceGroup.default)(function (_ref2) {
  var baseTheme = _ref2.theme;
  return (0, _themes.mapComponentThemes)({
    name: 'CheckboxGroup',
    theme: (0, _themes2.checkboxGroupTheme)(baseTheme)
  }, {
    name: 'ChoiceGroup',
    theme: {}
  }, baseTheme);
});
exports.CheckboxGroupRoot = CheckboxGroupRoot;